import { render } from "./requirement_data.vue?vue&type=template&id=0a50268b&scoped=true"
import script from "./requirement_data.vue?vue&type=script&lang=js"
export * from "./requirement_data.vue?vue&type=script&lang=js"

import "./requirement_data.vue?vue&type=style&index=0&id=0a50268b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a50268b"]])

export default __exports__